
export enum Stage {
  DEV = 'Dev',
  BETA = 'Beta',
  PROD = 'Prod',
}

export const STAGE_HOSTNAMES: Record<Stage, string[]> = {
  [Stage.DEV]: ['localhost'],
  [Stage.BETA]: ['beta.adslots.in-adtech.amazon.dev', 'd99zdo8o8lxqb.cloudfront.net'],
  [Stage.PROD]: ['adslots.in-adtech.amazon.dev', 'd1oi3giqqp2r8i.cloudfront.net'],
};

/**
 * Parses the stage from the given url.
 * @param url url object.
 * @returns Stage of the application (Ex. Beta, Prod).
 */
export const parseStageFromUrl = (url: URL): Stage => {
  const hostname = url.hostname;

  if (STAGE_HOSTNAMES[Stage.BETA].includes(hostname)) {
    return Stage.BETA;
  } else if (STAGE_HOSTNAMES[Stage.PROD].includes(hostname)) {
    return Stage.PROD;
  }

  return Stage.DEV;
};

export const getStage = (): Stage => {
  const url = new URL(window.location.href);
  return parseStageFromUrl(url);
};
